<template>
    <div class="row no-gutters">
        <div class="col-12">
            <div class="row no-gutters justify-content-center">
                <div class="col-12 statistics-header">
                    <div class="row no-gutters justify-content-center">
                        <span class="text my-4 statistics-title-text">STATISTICS</span>
                    </div>
                    <div class="row no-gutters justify-content-space-evenly">
                        <div v-bind:class="{'tab-header-clicked': statisticsTabStates.horseIndex}" v-on:click="onStatisticsTabClicked('horseIndex')" class="col-5 col-md-2 text tab-header text-center"><span>HORSE INDEX</span></div >
                        <div v-bind:class="{'tab-header-clicked': statisticsTabStates.trainerIndex}" v-on:click="onStatisticsTabClicked('trainerIndex')" class="col-5 col-md-2 text tab-header text-center"><span>TRAINER INDEX</span></div >
                        <div v-bind:class="{'tab-header-clicked': statisticsTabStates.jockeyIndex}" v-on:click="onStatisticsTabClicked('jockeyIndex')" class="col-5 col-md-2 text tab-header text-center"><span>JOCKEY INDEX</span></div >
                        <div v-bind:class="{'tab-header-clicked': statisticsTabStates.breedingIndex}" v-on:click="onStatisticsTabClicked('breedingIndex')" class="col-5 col-md-2 text tab-header text-center"><span>BREEDING INDEX</span></div >
                        <div v-bind:class="{'tab-header-clicked': statisticsTabStates.search}" v-on:click="onStatisticsTabClicked('search')" class="col-5 col-md-2 text tab-header text-center"><span>SEARCH</span></div >
                    </div>
                </div>
                <div v-if="statisticsTabStates.horseIndex" class="col-11">
                    <div class="row no-gutters d-flex justify-content-space-evenly my-3">
                        <button type="" class="col-5 col-xl-2 filter-button">Last 30 Races</button>
                        <button class="col-5 col-xl-2 filter-button">All Racecourses</button>
                        <button class="col-5 col-xl-2 filter-button">All Distances</button>
                        <button class="col-5 col-xl-2 filter-button">All Age</button>
                        <button class="col-5 col-xl-2 filter-tag">Filter</button>
                    </div>
                    <div class="row no-gutters d-flex justify-content-space-evenly">
                        <div class="table-responsive">
                            <table class="table">
                                <thead class="thead-dark">
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">HORSE</th>
                                    <th scope="col">RUNNERS</th>
                                    <th scope="col">WINS</th>
                                    <th scope="col">WINS%</th>
                                    <th scope="col">WINS/PL%</th>
                                    <th scope="col">2ND</th>
                                    <th scope="col">3ND</th>
                                    <th scope="col">4ND</th>
                                    <th scope="col">R1 WIN</th>
                                    <th scope="col">STAKE</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(horseData, index) in horseIndexData" :key="index">
                                    <td scope="row">{{horseData.index}}</td>
                                    <td scope="row" class="clickable-text" v-on:click="onHorseNameClicked('horseId')">{{horseData.name}}</td>
                                    <td scope="row">{{horseData.runs}}</td>
                                    <td scope="row">{{horseData.wins}}</td>
                                    <td scope="row">{{horseData.winperc}}</td>
                                    <td scope="row">{{horseData.winplaceperc}}</td>
                                    <td scope="row">{{horseData.second}}</td>
                                    <td scope="row">{{horseData.third}}</td>
                                    <td scope="row">{{horseData.fourth}}</td>
                                    <td scope="row">{{horseData.firstRunWin}}</td>
                                    <td scope="row">{{horseData.stakes}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div v-if="statisticsTabStates.trainerIndex" class="col-11">
                    <div class="row no-gutters d-flex justify-content-space-evenly my-3">
                        <button type="" class="col-5 col-xl-2 filter-button">Last 30 Races</button>
                        <button class="col-5 col-xl-2 filter-button">All Racecourses</button>
                        <button class="col-5 col-xl-2 filter-button">All Distances</button>
                        <button class="col-5 col-xl-2 filter-button">All Age</button>
                        <button class="col-5 col-xl-2 filter-tag">Filter</button>
                    </div>
                    <div class="row no-gutters d-flex justify-content-space-evenly">
                        <div class="table-responsive">
                            <table class="table">
                                <thead class="thead-dark">
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">TRAINER</th>
                                    <th scope="col">RUNNERS</th>
                                    <th scope="col">WINS</th>
                                    <th scope="col">WINS%</th>
                                    <th scope="col">WINS/PL%</th>
                                    <th scope="col">STAKE</th>
                                    <th scope="col">AEPR</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(trainerData, index) in trainerIndexData" :key="index">
                                    <td scope="row">{{trainerData.index}}</td>
                                    <td scope="row" class="clickable-text" v-on:click="onTrainerNameClicked('trainerId')">{{trainerData.name}}</td>
                                    <td scope="row">{{trainerData.runs}}</td>
                                    <td scope="row">{{trainerData.wins}}</td>
                                    <td scope="row">{{trainerData.winperc}}</td>
                                    <td scope="row">{{trainerData.winplaceperc}}</td>
                                    <td scope="row">{{trainerData.stakes}}</td>
                                    <td scope="row">{{trainerData.stakes}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div v-if="statisticsTabStates.jockeyIndex" class="col-11">
                    <div class="row no-gutters d-flex justify-content-space-evenly my-3">
                        <button class="col-5 col-xl-2 filter-button">Last 30 Races</button>
                        <button class="col-5 col-xl-2 filter-button">All Racecourses</button>
                        <button class="col-5 col-xl-2 filter-button">All Distances</button>
                        <button class="col-5 col-xl-2 filter-button">All Age</button>
                        <button class="col-5 col-xl-2 filter-tag">Filter</button>
                    </div>
                    <div class="row no-gutters d-flex justify-content-space-evenly">
                        <div class="table-responsive">
                            <table class="table">
                                <thead class="thead-dark">
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">JOCKEY</th>
                                    <th scope="col">RUNNERS</th>
                                    <th scope="col">WINS</th>
                                    <th scope="col">WINS%</th>
                                    <th scope="col">WINS/PL%</th>
                                    <th scope="col">STAKE</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(jockeyData, index) in jockeyIndexData" :key="index">
                                    <td scope="row">{{jockeyData.index}}</td>
                                    <td scope="row" class="clickable-text" v-on:click="onJockeyNameClicked('jockeyId')">{{jockeyData.name}}</td>
                                    <td scope="row">{{jockeyData.runs}}</td>
                                    <td scope="row">{{jockeyData.wins}}</td>
                                    <td scope="row">{{jockeyData.winperc}}</td>
                                    <td scope="row">{{jockeyData.winplaceperc}}</td>
                                    <td scope="row">{{jockeyData.stakes}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div v-if="statisticsTabStates.breedingIndex" class="col-11">
                    <div class="row no-gutters my-2">
                        <button class="breeder-type-toggle col-3 col-lg-2 btn" v-bind:class="{'breeder-type-toggle-selected': breederToggleStates.breeders}" v-on:click="onBreederToggleClicked('breeders')">BREEDERS</button>
                        <button class="breeder-type-toggle col-3 col-lg-2 btn" v-bind:class="{'breeder-type-toggle-selected': breederToggleStates.sires}" v-on:click="onBreederToggleClicked('sires')">SIRES</button>
                        <button class="breeder-type-toggle col-3 col-lg-2 btn" v-bind:class="{'breeder-type-toggle-selected': breederToggleStates.damsires}" v-on:click="onBreederToggleClicked('damsires')">DAMSIRES</button>
                    </div>
                    <div class="row no-gutters d-flex justify-content-space-evenly">
                        <div class="table-responsive">
                            <table class="table">
                                <thead class="thead-dark">
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">BREEDERS</th>
                                    <th scope="col">RUNNERS</th>
                                    <th scope="col">AEPR</th>
                                    <th scope="col">RUNS</th>
                                    <th scope="col">WNRS</th>
                                    <th scope="col">WNS</th>
                                    <th scope="col">WNR/RN%</th>
                                    <th scope="col">SW/WNRS</th>
                                    <th scope="col">SW/WNS</th>
                                    <th scope="col">SW/WNR%</th>
                                    <th scope="col">PLCS</th>
                                    <th scope="col">PL/RNS%</th>
                                    <th scope="col">SP</th>
                                    <th scope="col">TOP ERNER & STAKE</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(breederData, index) in breederIndexData" :key="index">
                                    <td scope="row">{{breederData.index}}</td>
                                    <td scope="row" class="clickable-text" v-on:click="onBreederNameClicked('breederId')">{{breederData.name}}</td>
                                    <td scope="row">{{breederData.runners}}</td>
                                    <td scope="row">{{breederData.aepr}}</td>
                                    <td scope="row">{{breederData.runs}}</td>
                                    <td scope="row">{{breederData.wnrs}}</td>
                                    <td scope="row">{{breederData.wins}}</td>
                                    <td scope="row" class="text-center">{{breederData.winnerRunPerc}}</td>
                                    <td scope="row" class="text-center">{{breederData.swWinners}}</td>
                                    <td scope="row" class="text-center">{{breederData.swWins}}</td>
                                    <td scope="row" class="text-center">{{breederData.swPerWnrPerc}}</td>
                                    <td scope="row">{{breederData.place}}</td>
                                    <td scope="row">{{breederData.placePerRnrPerc}}</td>
                                    <td scope="row">{{breederData.sp}}</td>
                                    <td scope="row">{{breederData.topEarnerAndStake}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div v-if="statisticsTabStates.search" class="col-12">
                    <div class="row no-gutters d-flex mt-3 justify-content-center justify-content-lg-end mr-xl-3">
                        <input type="input" class="mr-2 search-input" placeholder="Enter name..."/>
                        <button class="search-button">Search</button>
                    </div>
                    <horse-statistics v-if="selectedHorse" :formGridToggleCallback="toggleFormGridVisibility" :selectedHorse="selectedHorse"></horse-statistics>
                    <trainer-statistics v-if="selectedTrainer" :formGridToggleCallback="toggleFormGridVisibility" :selectedTrainer="selectedTrainer"></trainer-statistics>
                    <jockey-statistics v-if="selectedJockey" :formGridToggleCallback="toggleFormGridVisibility" :selectedJockey="selectedJockey"></jockey-statistics>
                    <breeder-statistics v-if="selectedBreeder" :formGridToggleCallback="toggleFormGridVisibility" :selectedBreeder="selectedBreeder"></breeder-statistics>
                </div>
            </div>
        </div>
        <form-grid-modal v-if="isFormGridOpen" :toggleFormGridVisibilityCallback="toggleFormGridVisibility"></form-grid-modal>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';

    import {TrainerIndexMockData} from '../assets/mockData/trainerIndex';
    import {BreederIndexMockData} from '../assets/mockData/breedingIndex';
    import {JockeyIndexMockData} from '../assets/mockData/jockeyIndex';
    import {HorseIndexMockData} from '../assets/mockData/horseIndex';

    import JockeyStatistics from '../components/JockeyStatistics';
    import BreederStatistics from '../components/BreederStatistics';
    import HorseStatistics from '../components/HorseStatistics';
    import TrainerStatistics from '../components/TrainerStatistics';

    import FormGridModal from '../components/FormGridModal';

    export default {
        name: 'Statistics',
        components: {HorseStatistics, TrainerStatistics, JockeyStatistics, BreederStatistics, FormGridModal},
        data: function () {
            return {
                statisticsTabStates: {
                    horseIndex: true,
                    trainerIndex: false,
                    jockeyIndex: false,
                    breedingIndex: false,
                    search: false
                },
                breederToggleStates: {
                  breeders: true,
                  sires: false,
                  damsires: false
                },
                isFormGridOpen: false,
                trainerIndexData: TrainerIndexMockData,
                breederIndexData: BreederIndexMockData,
                jockeyIndexData: JockeyIndexMockData,
                horseIndexData: HorseIndexMockData
            };
        },
        computed: mapState(['selectedHorse', 'selectedTrainer', 'selectedJockey', 'selectedBreeder']),
        methods: {
            getImage(imagePath, fileType = 'svg') {
                return require('../assets/images/' + imagePath + '.' + fileType);
            },
            onStatisticsTabClicked(tabName) {
                if (this.statisticsTabStates[tabName]) return;
                for(let tab in this.statisticsTabStates) {
                    if(this.statisticsTabStates[tab] && tabName === tab) {
                        this.statisticsTabStates[tab] = false;
                        return;
                    }
                    this.statisticsTabStates[tab] = tab === tabName;
                }
            },
            onBreederToggleClicked(toggleName) {
                if (this.breederToggleStates[toggleName]) return;
                for(let toggle in this.breederToggleStates) {
                    if(this.breederToggleStates[toggle] && toggleName === toggle) {
                        this.breederToggleStates[toggle] = false;
                        return;
                    }
                    this.breederToggleStates[toggle] = toggle === toggleName;
                }
            },
            onHorseNameClicked(horseId) {
                this.setSelectedHorse({});
                this.onStatisticsTabClicked('search');
            },
            onTrainerNameClicked(trainerId) {
                this.setSelectedTrainer({});
                this.onStatisticsTabClicked('search');
            },
            onJockeyNameClicked(jockeyId) {
                this.setSelectedJockey({});
                this.onStatisticsTabClicked('search');
            },
            onBreederNameClicked(breederId) {
                this.setSelectedBreeder({});
                this.onStatisticsTabClicked('search');
            },
            toggleFormGridVisibility() {
              this.isFormGridOpen = !this.isFormGridOpen;
            },
            ...mapMutations(['setSelectedHorse', 'setSelectedTrainer', 'setSelectedJockey', 'setSelectedBreeder'])
        },
        mounted: function () {
            if (this.selectedHorse || this.selectedTrainer || this.selectedJockey || this.selectedBreeder) this.onStatisticsTabClicked('search');
        }
    }
</script>

<style scoped>
    .table td {
        padding-top: 0.4rem;
        padding-bottom: 0.4rem;
    }

    .statistics-header {
        background-color: #000000;
    }

    .statistics-title-text {
        font-size: 1.8rem;
    }

    .tab-header {
        font-size: 0.8rem;
        padding: 0.5rem 0;
        font-weight: bold;
    }

    .tab-header:hover {
        cursor: pointer;
    }

    .tab-header-clicked {
        background-color: #FFFFFF;
        color: #000000;
    }

    .table-responsive {
        border: 1px solid #7c7c7c !important;
        margin-bottom: 0.5rem !important;
        box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.4);
    }

    .breeder-type-toggle {
        background-color: #FFFFFF;
        border: #000000 solid 1px;
        color: #000000;
        font-size: 0.8rem;
        margin: 1.2rem 0.5rem 1.2rem 0;
    }

    .breeder-type-toggle-selected {
        border: none;
        background-color: black;
        color: #FFFFFF;
    }

    .search-input {
        width: 12rem;
    }

    .search-button {
        width: 6rem;
    }

    @media only screen and (min-device-width: 0px) and (max-device-width: 1200px) and (orientation: landscape) {
    }

    @media (min-width: 1200px) {
        .table td {
            padding-top: 0.75rem;
            padding-bottom: 0.75rem;
        }

        .tab-header {
            font-size: 1rem;
            padding: 0.5rem 0;
            font-weight: bold;
        }

        .breeder-type-toggle {
            font-size: 1.5rem !important;
        }

        .search-input {
            width: 16rem;
        }

        .search-button {
            width: 7rem;
        }
    }
</style>
